import script from "./StudentDisciplinaryDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentDisciplinaryDialog.vue?vue&type=script&setup=true&lang=js"

import "./StudentDisciplinaryDialog.vue?vue&type=style&index=0&id=9675f0ac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9675f0ac"]])

export default __exports__